import { Component, ElementRef } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'bo-sidebar',
  templateUrl: './app.sidebar.component.html',
  standalone: false,
})
export class AppSidebarComponent {
  constructor(public layoutService: LayoutService, public el: ElementRef) {}
}
